import { Chess } from '../js';

export let game = new Chess();
